import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let TaskSchedulerFrontendAdminFeature = /*#__PURE__*/(() => {
  let TaskSchedulerFrontendAdminFeature = class TaskSchedulerFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/task-scheduler/frontend-admin","featureId":"common-task-scheduler"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Aufgabenplanung',
          routerLink: 'task-scheduler',
          priority: 5,
          icon: 'calendar-days'
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵTaskSchedulerFrontendAdminFeature_BaseFactory;
        return function TaskSchedulerFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵTaskSchedulerFrontendAdminFeature_BaseFactory || (ɵTaskSchedulerFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(TaskSchedulerFrontendAdminFeature)))(__ngFactoryType__ || TaskSchedulerFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: TaskSchedulerFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'task-scheduler',
          loadChildren: () => import('./task-scheduler-admin.module').then(m => m.TaskSchedulerAdminModule)
        }])],
        imports: [CommonModule]
      });
    }
  };
  TaskSchedulerFrontendAdminFeature = __decorate([ClassName("TaskSchedulerFrontendAdminFeature")], TaskSchedulerFrontendAdminFeature);
  return TaskSchedulerFrontendAdminFeature;
})();
export { TaskSchedulerFrontendAdminFeature };